// BanksTable.jsx
import { Box } from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { AccountsandFinanceurl } from "../../../../config";
import { BanksColumns } from "../../../../data/DynamicTable/AccountsColumns";
import { allBanks } from "../../../../data/Axios/queries";
import BankForm from "./form";


const base_url = AccountsandFinanceurl.uri;

const actions = {
  entity: "Banks",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: false,
    permission: "ActivatePermission",
  },
  viewJournalEntries: { // New action for journal entries
    key: "VIEW_JOURNAL_ENTRIES",
    button_name: "View Journal Entries",
    Show_Button: true,
    permission: "ViewJournalEntriesPermission",
    query: "allJournalLinesByColumnValues", // Query to fetch journal entries
    inputFields: (row) => ({ // Dynamic input fields based on row data
      accountID: row.id,
      cancelled: null,
    }),
    returnFields: [
      "journalLineID",
      "journalEntryID",
      "accountID",
      "debit",
      "credit",
      "description",
      "createdDate",
      "caseId",
      "applicationId",
      "applicationType",
    ],
  },
  showStatus: true,
};

function BanksTable() {
  return (
    <Box m="2px">
      <DynamicTable
        title="Banks"
        subtitle="Create, view or edit banks"
        columns={BanksColumns}
        FormComponent={BankForm}
        query={allBanks}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default BanksTable;